import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>Company</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/who-we-serve">Who We Serve</Link></li>
            <li><Link to="/faqs">FAQs</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h3>Services</h3>
          <ul>
            <li><Link to="/services/abandoned-freight">Abandoned Freight</Link></li>
            <li><Link to="/services/store-closing">Store Closing</Link></li>
            <li><Link to="/services/customer-returns">Customer Returns</Link></li>
            <li><Link to="/services/itad">IT Disposition</Link></li>
            <li><Link to="/services/donations">Charitable Donations</Link></li>
            <li><Link to="/services/excessive-inventory">Excessive Inventory</Link></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/services">All Services</Link></li>
            <li><Link to="/faqs">FAQs</Link></li>
            <li><Link to="/contact">Get in Touch</Link></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h3>Resources</h3>
          <ul>
            <li><Link to="/faqs">Compliance & Certifications</Link></li>
            <li><Link to="/faqs">Sustainability</Link></li>
            <li><a href="mailto:info@globoflo.com">Email Us</a></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h3>Contact Info</h3>
          <div className="contact-info">
            <p><strong>HEADQUARTERS</strong><br />
            1058 Branch Drive<br />
            Alpharetta, GA 30004</p>
            <p><strong>PHONE</strong><br />
            +1 877-873-9336 (Toll Free)<br />
            +1 678-694-8347</p>
            <p><strong>EMAIL</strong><br />
            info@globoflo.com</p>
          </div>
        </div>

        <div className="footer-section">
          <h3>Follow</h3>
          <ul>
            <li><a href="https://www.linkedin.com" target="_blank" rel="noreferrer">LinkedIn</a></li>
            <li><a href="https://www.twitter.com" target="_blank" rel="noreferrer">Twitter/X</a></li>
            <li><a href="https://www.facebook.com" target="_blank" rel="noreferrer">Facebook</a></li>
          </ul>
        </div>
      </div>
      
      <div className="footer-bottom">
          <p>&copy; 2025 Globoflo. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
